import React from 'react';
import Lesson from '../Lesson';

import styled from 'styled-components';

import { DataContext } from '../DataProvider';

function CoursePreview({ item, data }) {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const {
    setSelectedCourse,
    setLessonsWereRequested,
    setLessonsWereFetched,
    setSelectedCourseTitle,
  } = React.useContext(DataContext);

  const extractCourseUrlSuffix = (url) => {
    const pattern = /https:\/\/chessmood.com\/course\/(.+)/;
    const match = url.match(pattern);
    return match ? match[1] : '';
  };

  const title = data.course_title;
  const thumbnailUrl = data.thumbnail_url;
  const courseUrl = data.course_url; // https://chessmood.com/course/elisabeth-paehtz-best-games
  const courseId = extractCourseUrlSuffix(courseUrl);

  const handleClick = () => {
    setIsExpanded((previous) => !previous);
    setSelectedCourse(courseId);
    setSelectedCourseTitle(title);
    setLessonsWereRequested(true);
    setLessonsWereFetched(false);
  };

  return (
    <span>
      <button onClick={() => handleClick()}>
        <CourseImage>
          <img src={thumbnailUrl} alt={title} />
          <figcaption>{title}</figcaption>
        </CourseImage>
      </button>
    </span>
  );
}

export default CoursePreview;

const CourseImage = styled.figure`
  margin: 0;
  img {
    width: 100%;
    height: auto;
  }
  figcaption {
    text-align: center; // Center the caption text
  }
`;
